import React, { Component } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { connect } from "react-redux";
import { randomBytes } from "crypto";
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faInfoCircle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

import {
  dropdownTransition,
  hiringTransition,
  navbarHeightDesktopScrolled,
} from "./navbar.scss";
import {
  fetchComplianceData,
  resetEventCompliance,
} from "redux/actions/portfolioAction";
import { leanplumTracker } from "helpers/tracker";
import { taraliteWhiteLogo } from "config/assets/logos";
import { Tkb90Content } from "./tkb-panel";

import { landscape } from "themes/_common.scss";
import LanguageSwitcher from "./language-switcher";
import {
  purpleOVOPaylaterLogo,
  grabModalMantulLogo,
  purpleOVOModalUsahaLogo,
} from "config/assets/logos";
class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      navbarClassname: ["navbar"],
      dropdownClassname: ["dropdown-menu", "hidden-dropdown-menu"],
      disableChangeLanguage: false,
      toggleHiringButton: false,
      contactFormState: false,
      isMobile: false,
    };
    this.navbarItems = [
      {
        id: "product",
        subItems: [
          {
            id: "ovoPaylater",
            route: "/paylater",
            imgSrc: purpleOVOPaylaterLogo,
          },
          {
            id: "grabModalMantul",
            route: "/GrabModalMantul",
            imgSrc: grabModalMantulLogo,
          },
          {
            id: "ovoModalUsaha",
            route: "/omu/landing/borrower",
            imgSrc: purpleOVOModalUsahaLogo,
          },
        ],
      },
      {
        id: "about-us",
        route: "/about",
      },
      // disabled until feature available
      {
        id: "contact",
        route: "#contact",
      },
    ];
    this.onResizeHandler = this.onResizeHandler.bind(this);
    this.onScrollHandler = this.onScrollHandler.bind(this);
    this.getListItemClassNames = this.getListItemClassNames.bind(this);
    this.navbarClassIdentifier = `navbar-${randomBytes(10).toString("hex")}`;
    this.dropdownClassIdentifier = `dropdown-menu-${randomBytes(10).toString(
      "hex"
    )}`;
    this.minResponsiveWidth = Number(landscape.substr(0, landscape.length - 2));
    this.dropdownTransition = Number(
      dropdownTransition.substr(0, dropdownTransition.length - 2)
    );
    this.navbarHeightDesktopScrolled = Number(
      navbarHeightDesktopScrolled.substr(
        0,
        navbarHeightDesktopScrolled.length - 2
      )
    );
    this.hiringTransition = parseInt(hiringTransition, 10);
    this.isNavbarScrolled = false;
    this.isEventAttached = false;
  }
  manipulateClassname(status, stateName, className, cb) {
    const callCb = () => {
      if (cb && typeof cb === "function") {
        cb();
      }
    };
    if (status && !this.state[stateName].includes(className)) {
      // Adding class
      this.setState(
        (prevState) => ({
          [stateName]: [...prevState[stateName], className],
        }),
        () => callCb()
      );
    } else if (!status && this.state[stateName].includes(className)) {
      // Removing class
      this.setState(
        (prevState) => {
          let newValue = prevState[stateName].slice(0);
          newValue.splice(prevState[stateName].indexOf(className), 1);
          return { [stateName]: newValue };
        },
        () => callCb()
      );
    }
  }

  getListItemClassNames(route, subItems) {
    const { pathname } = this.props.location;
    let className = "";
    className = pathname.includes(route) ? "list active" : "list";
    if (subItems) {
      className += " list-has-sub-item";
    }
    return className;
  }
  toggleDropdown(state) {
    const dropdownMenu = document.querySelector(
      `.${this.dropdownClassIdentifier}`
    );
    if (state) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      dropdownMenu.style.display = "block";
      dropdownMenu.scrollTo(0, 0);
      setTimeout(() => {
        this.manipulateClassname(
          false,
          "dropdownClassname",
          "hidden-dropdown-menu"
        );
      }, 5);
    } else {
      this.manipulateClassname(
        true,
        "dropdownClassname",
        "hidden-dropdown-menu",
        () => {
          setTimeout(() => {
            dropdownMenu.style.display = "none";
            document.getElementsByTagName("body")[0].removeAttribute("style");
          }, this.dropdownTransition);
        }
      );
    }
  }
  clickDropdownOverlay(e) {
    if (e.target === e.currentTarget) {
      this.toggleDropdown(false);
    }
  }

  shrinkTaraliteLogo(state) {
    const { taraliteLogo } = this.refs;
    // Toggle taralite logo
    if (taraliteLogo) {
      !state
        ? taraliteLogo.removeAttribute("style")
        : (taraliteLogo.style.width = "78px");
    }
  }
  slideDownNavbar() {
    const navbar = document.querySelector(`.${this.navbarClassIdentifier}`);
    if (!this.isNavbarScrolled) {
      navbar.style.top = `-${this.navbarHeightDesktopScrolled}px`;
      setTimeout(() => {
        this.manipulateClassname(
          true,
          "navbarClassname",
          "navbar-scrolled",
          () => {
            navbar.style.top = null;
          }
        );
      }, 5);
    }
  }
  toggleContactForm() {
    if (document.querySelector(`.${this.dropdownClassIdentifier}`)) {
      this.toggleDropdown(false);
    }
    this.setState((prevState) => ({
      contactFormState: !prevState.contactFormState,
    }));
  }
  // Event Handler
  onScrollHandler(e) {
    const navbar = document.querySelector(`.${this.navbarClassIdentifier}`);
    if (window.scrollY > 0) {
      this.slideDownNavbar();
      this.isNavbarScrolled = true;
      // Toggle taralite logo
      if (window.innerWidth <= this.minResponsiveWidth) {
        this.shrinkTaraliteLogo(true);
      } else if (window.innerWidth > this.minResponsiveWidth) {
        navbar.style.height = `${this.navbarHeightDesktopScrolled}px`;
        this.shrinkTaraliteLogo(false);
      }
    } else {
      this.isNavbarScrolled = false;
      this.manipulateClassname(
        false,
        "navbarClassname",
        "navbar-scrolled",
        () => {
          navbar.removeAttribute("style");
        }
      );
      // Toggle taralite logo
      if (window.innerWidth <= this.minResponsiveWidth) {
        this.shrinkTaraliteLogo(true);
      }
    }
  }
  onResizeHandler(e) {
    const isMobile = window.innerWidth <= this.minResponsiveWidth;
    const navbar = document.querySelector(`.${this.navbarClassIdentifier}`);
    if (!isMobile) {
      this.isEventAttached = false;
      this.shrinkTaraliteLogo(false);
      if (window.scrollY !== 0) {
        navbar.style.height = `${this.navbarHeightDesktopScrolled}px`;
      }
    } else {
      if (window.scrollY === 0) {
        this.shrinkTaraliteLogo(true);
      } else {
        navbar.style.height = null;
        this.shrinkTaraliteLogo(true);
      }
    }
    this.setState(
      (prevState) => ({ isMobile }),
      () => {
        const dropdownMenu = document.querySelector(
          `.${this.dropdownClassIdentifier}`
        );
        if (this.state.isMobile) {
          if (!this.isEventAttached) {
            dropdownMenu.addEventListener(
              "click",
              this.clickDropdownOverlay.bind(this)
            );
            this.isEventAttached = true;
          }
        } else {
          this.manipulateClassname(
            true,
            "dropdownClassname",
            "hidden-dropdown-menu"
          );
        }
      }
    );
  }

  // Hooks
  componentWillMount() {
    dom.watch();
    library.add(faBars, faInfoCircle, faTimes);
    this.manipulateClassname(
      true,
      "navbarClassname",
      this.navbarClassIdentifier
    );
    this.manipulateClassname(
      true,
      "dropdownClassname",
      this.dropdownClassIdentifier
    );
    document.getElementsByTagName("body")[0].removeAttribute("style");
    // Attach scroll event to window DOM
    window.addEventListener("scroll", this.onScrollHandler);
    // Attach resize event to window DOM
    window.addEventListener("resize", this.onResizeHandler);
    // Detect initial screen size type
    this.setState({
      isMobile: window.innerWidth <= this.minResponsiveWidth,
      disableChangeLanguage: this.props.location.pathname === "/career",
    });
  }
  componentDidMount() {
    const dropdownMenu = document.querySelector(
      `.${this.dropdownClassIdentifier}`
    );
    this.onResizeHandler();
    if (dropdownMenu) {
      dropdownMenu.addEventListener(
        "click",
        this.clickDropdownOverlay.bind(this)
      );
      this.isEventAttached = true;
    }

    if (!this.props.tkb90) {
      this.props.resetEventCompliance();
      this.props.fetchComplianceData();
    }

    if (this.props.isFixed) {
      const navbar = document.querySelector(".navbar");
      navbar.style.height = `${this.navbarHeightDesktopScrolled}px`;
      this.manipulateClassname(true, "navbarClassname", "navbar-scrolled");
      this.isNavbarScrolled = true;
      window.removeEventListener("scroll", this.onScrollHandler);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScrollHandler);
    window.removeEventListener("resize", this.onResizeHandler);
  }

  productNavbarTracker() {
    leanplumTracker("homepage", {
      Trigger: "Text Click",
      TriggerValue: "Produk",
      Product: "Taralite Website",
      Page: "Homepage",
      Description: "Text Click - Produk - Taralite Website - Homepage",
    });
  }

  render() {
    const { selected, languageData } = this.props.language;
    const { navbar } = languageData[selected];
    return (
      <div className={this.state.navbarClassname.join(" ")} ref="navbar">
        <div className="navbar-container">
          <div className="navbar-width-set">
            {/* TODO */}
            <img
              className="navbar-logo"
              src={taraliteWhiteLogo}
              alt="logo taralite"
              onClick={() => this.props.history.push("/")}
            />
            {this.props.isHiring && this.props.isHiring.state ? (
              <a
                href="https://taralite.typeform.com/to/RyWL2k"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="main-gradient-button hiring-button">
                  {this.props.isHiring.text}
                </button>
              </a>
            ) : null}
            <div className="navbar-items-container">
              <ul className="navbar-items-content">
                {this.navbarItems.map((each) => (
                  <li
                    key={each.id}
                    className={this.getListItemClassNames(
                      each.route,
                      each.subItems
                    )}
                    onClick={
                      each.id === "product"
                        ? () => this.productNavbarTracker()
                        : null
                    }
                  >
                    {each.hasOwnProperty("route") ? (
                      <Link smooth to={each.route}>
                        {navbar[each.id]}
                      </Link>
                    ) : each.hasOwnProperty("render") ? (
                      each.render(navbar[each.id])
                    ) : (
                      <p>{navbar[each.id]}</p>
                    )}

                    {each.hasOwnProperty("subItems") ? (
                      <ul className="list-sub-item">
                        {each.subItems.map((subItem) => {
                          return (
                            <li
                              key={subItem.id}
                              className={this.getListItemClassNames(
                                subItem.route,
                                each.subItems
                              )}
                            >
                              <Link to={subItem.route}>
                                <img
                                  src={subItem.imgSrc}
                                  alt={navbar[subItem.id]}
                                  style={
                                    subItem.id !== "ovoPaylater"
                                      ? { width: "12rem" }
                                      : null
                                  }
                                />
                                <i className="fas fa-angle-right" />
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    ) : null}
                  </li>
                ))}
                <li className="tkb90-container">
                  <Tkb90Content
                    data={
                      this.props.tkb90 &&
                      this.props.tkb90[selected] &&
                      this.props.tkb90[selected].tkb
                    }
                    language={selected}
                  />
                </li>
              </ul>
              {!this.state.disableChangeLanguage ? (
                <div className="language-switcher-desktop">
                  <LanguageSwitcher />
                </div>
              ) : null}
            </div>
            <div className="tkb90-container tkb90-container-mobile">
              <Tkb90Content
                data={
                  this.props.tkb90 &&
                  this.props.tkb90[selected] &&
                  this.props.tkb90[selected].tkb
                }
                language={selected}
              />
            </div>
            <button
              className="show-dropdown"
              onClick={() => this.toggleDropdown(true)}
            >
              <i className="fas fa-bars" />
            </button>
            {this.state.isMobile ? (
              <div
                style={{ display: "none" }}
                className={this.state.dropdownClassname.join(" ")}
              >
                <div className="dropdown-wrapper">
                  <div className="dropdown-header">
                    <Link to="/">
                      <span className="taralite-icon" />
                    </Link>
                    <button
                      className="close-button"
                      onClick={() => this.toggleDropdown(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                  <div className="dropdown-content">
                    <ul className="dropdown-items-content">
                      {this.navbarItems.map((each) => (
                        <li key={each.id}>
                          {each.hasOwnProperty("route") ? (
                            <Link to={each.route}>{navbar[each.id]}</Link>
                          ) : each.hasOwnProperty("render") ? (
                            each.render(navbar[each.id])
                          ) : (
                            <p>{navbar[each.id]}</p>
                          )}

                          {each.hasOwnProperty("subItems") ? (
                            <ul className="list-sub-item list-sub-item-mobile">
                              {each.subItems.map((subItem) => {
                                return (
                                  <li
                                    key={subItem.id}
                                    className={this.getListItemClassNames(
                                      subItem.route,
                                      each.subItems
                                    )}
                                  >
                                    <Link to={subItem.route}>
                                      {navbar[subItem.id]}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          ) : null}
                        </li>
                      ))}
                    </ul>
                    <hr />
                    <span>
                      <a href="/omu/landing/borrower#faq">
                        {languageData[selected].footer.sitemap.faq}
                      </a>
                    </span>
                    <span>
                      <a
                        target="_blank"
                        href="/assets/documents/terms-condition.pdf"
                      >
                        {languageData[selected].footer.sitemap.terms_condition}
                      </a>
                    </span>
                    <span>
                      <a href="/privacy-notice">
                        {
                          languageData[selected].footer.sitemap
                            .privacy_policy_new
                        }
                      </a>
                    </span>
                    <span>
                      <a
                        target="_blank"
                        href="/assets/documents/complaint-procedure.pdf"
                      >
                        {
                          languageData[selected].footer.sitemap
                            .complaint_procedure
                        }
                      </a>
                    </span>
                    {!this.state.disableChangeLanguage ? (
                      <LanguageSwitcher className="language-switcher-mobile" />
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ languageReducer, portfolioReducer }) => ({
  tkb90: portfolioReducer.statistics,
  language: languageReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchComplianceData: () => dispatch(fetchComplianceData()),
  resetEventCompliance: () => dispatch(resetEventCompliance()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
